(function () {
  var DT_MAP = {
    '素材': 'Material:',
    '仕上げ': 'Finish:',
    '状態': 'Condition:',
    '重量': 'Weight:',
    'コード': 'Cord:'
  };

  function initSection(root) {
    if (root.dataset.specsInitialized) return;
    root.dataset.specsInitialized = 'true';

    var specsEl = root.querySelector('.product__specs');
    var noticeEl = root.querySelector('.product__notice');

    function moveWdhToSpecs() {
      if (!specsEl) return;

      root.querySelectorAll('.product__text .wdh').forEach(function (wdh) {
        var p = document.createElement('p');
        p.className = 'product__sizes';
        p.innerHTML = wdh.innerHTML;
        specsEl.appendChild(p);
        wdh.parentNode.removeChild(wdh);
      });
    }

    function moveShippingToSpecs() {
      if (!specsEl) return;

      root.querySelectorAll('.product__text .shipping').forEach(function (shipping) {
        var content;
        if (shipping.tagName === 'UL') {
          var firstLi = shipping.querySelector('li');
          if (!firstLi) return;
          content = firstLi.innerHTML;
        } else {
          content = shipping.innerHTML;
        }

        var p = document.createElement('p');
        p.className = 'product__shipping';
        p.innerHTML = content;
        specsEl.appendChild(p);
        shipping.parentNode.removeChild(shipping);
      });
    }

    function moveSpecToSpecs() {
      if (!specsEl) return;

      root.querySelectorAll('.product__text .spec').forEach(function (spec) {
        var dl = spec.cloneNode(true);
        dl.className = 'product__spec';
        dl.querySelectorAll('dt').forEach(function (dt) {
          var text = dt.textContent.trim();
          if (DT_MAP[text]) dt.textContent = DT_MAP[text];
        });
        specsEl.appendChild(dl);
        spec.parentNode.removeChild(spec);
      });
    }

    function replaceContactLinks() {
      var textEl = root.querySelector('.product__text[data-product-handle]');
      if (!textEl) return;
      var handle = textEl.dataset.productHandle;

      textEl.querySelectorAll('a').forEach(function (a) {
        if (a.href.startsWith('https://secure.shop-pro.jp/')) {
          a.href = '/pages/contact?inq=' + handle;
        }
      });
    }

    function replacePidLinks() {
      var textEl = root.querySelector('.product__text');
      if (!textEl) return;

      var pattern = /^https?:\/\/icca-life\.com\/\?pid=(\d+)$/;

      textEl.querySelectorAll('a').forEach(function (a) {
        var rawHref = a.getAttribute('href');
        if (!rawHref) return;

        var match = rawHref.match(pattern);
        if (!match) return;

        var pid = match[1];
        var newHref = 'https://icca-life.com/products/' + pid;
        a.setAttribute('href', newHref);

        // リンクテキストが旧 URL 形式の場合も変換
        if (pattern.test(a.textContent.trim())) {
          a.textContent = newHref;
        }
      });
    }

    function moveDetailMainToSpecs() {
      if (!specsEl) return;

      var detailMain = root.querySelector('.product__text .detail_main');
      if (!detailMain) return;

      var toggles = detailMain.querySelectorAll('.toggle.alpha');
      toggles.forEach(function (toggle) {
        var label = toggle.textContent.trim();
        var menu = toggle.nextElementSibling;
        if (!menu || !menu.classList.contains('togglemenu')) return;

        var p = menu.querySelector('p');
        if (!p) return;

        if (label === 'SIZE') {
          var sizeP = p.cloneNode(true);
          sizeP.className = 'product__sizes';
          console.log(sizeP);
          specsEl.appendChild(sizeP);
        } else if (label === '送料サイズ') {
          var match = p.textContent.match(/サイズ[：:]\s*(\d+)/);
          if (match) {
            var shippingP = document.createElement('p');
            shippingP.className = 'shipping';
            shippingP.textContent = '送料サイズ: ' + match[1];
            specsEl.appendChild(shippingP);
          }
        }
      });

      detailMain.parentNode.removeChild(detailMain);
    }

    function moveNoticeToProductNotice() {
      if (!noticeEl) return;

      // 旧データ形式: .otherContainer > .notice > .col > p（.link を除外）
      var otherContainer = root.querySelector('.product__text .otherContainer');
      if (otherContainer) {
        var ul = document.createElement('ul');
        ul.className = 'notice';
        otherContainer.querySelectorAll('.notice .col p:not(.link)').forEach(function (p) {
          var li = document.createElement('li');
          li.innerHTML = p.innerHTML;
          ul.appendChild(li);
        });
        if (ul.children.length > 0) {
          noticeEl.appendChild(ul);
        }
        otherContainer.parentNode.removeChild(otherContainer);
        return;
      }

      // 新規データ形式: ul.notice を直接 .product__text 内に記述した場合
      var noticeUl = root.querySelector('.product__text ul.notice');
      if (noticeUl) {
        noticeEl.appendChild(noticeUl);
      }
    }

    replaceContactLinks();
    replacePidLinks();
    moveDetailMainToSpecs();
    moveWdhToSpecs();
    moveShippingToSpecs();
    moveSpecToSpecs();
    moveNoticeToProductNotice();
  }

  function run() {
    document.querySelectorAll('[data-product-specs-root]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
